import { Button } from "@/kit/ui/button";
import { ChevronLeftIcon, ChevronRightIcon } from "@/icons";
import { useContext } from "react";
import { CarouselContext } from "./context";

export function CarouselControl() {
  const { previous, next, index, maxIndex } = useContext(CarouselContext);

  return (
    <div className="flex flex-row items-center gap-1">
      <Button
        icon
        onClick={previous}
        variant="secondary"
        disabled={index === 0}
      >
        <ChevronLeftIcon className="h-5 w-5" />
      </Button>
      <Button
        icon
        variant="secondary"
        onClick={next}
        disabled={index === maxIndex}
      >
        <ChevronRightIcon className="h-5 w-5" />
      </Button>
    </div>
  );
}
